import React, { useState, useMemo } from 'react';
import { Search, Tag, ShieldOff } from 'lucide-react';
import AccountSwitcher from '../../../components/AccountSwitcher';

const CAMPAIGN_DATA = [
  {
    campaign: 'V3_SRCH_BRND',
    label: 'Gürgençler (Brand)',
    keywords: [
      '[gürgençler]', '[gurgencler]', '[gürgençler iletişim]', '[apple gürgençler]',
      '[gürgençler.com]', '[gürgençler mağaza]', '[gürgençler servis]', '[gürgençler satış]',
      '[gürgençler değiş tokuş]', '[gürgençler apple yetkili satıcı]',
      '[gürgençler apple premium reseller]', '[gürgençl]', '[gürgenç]', '[gürgenç apple]',
      '[gürgenler]', '[gurgenler]', '[gurgenç]', '[gürgenc]', '[gurgenc]',
      '[gürgeler]', '[gürecler]', '[gügençler]', '[güecler]', '[gurcenler]',
      '[www gürgençler]', '[www.gurgencler.com]', '[gurgencler.com]', '[gurgencler com tr]',
      '[apple gurgencler]', '[applegurgencler]', '[gurgençler apple]', '[gurgecler apple]',
      '"www gurgencler com tr"',
    ],
    negatives: [
      '[gürgençler batarya değişimi]', '[gürgençler cam değişimi]', '[gürgençler ekran değişimi]',
      '[iphone batarya değişimi]', '[iphone xr ekran değişimi]', '[macbook pro ekran değişimi fiyat]',
      '[gürgençler iphone 7 ekran değişimi ücreti]', '[apple servis cam değişimi fiyatı]',
      '[gürgençler aheze hoparlör değişimi]', '[gürgençler wifi değişimi ücreti]',
      '[iphone kılıf]', '[airpods kılıf]', '[ipad klavye]', '[apple watch şarj aleti]',
      '[apple kılıf]', '[iphone şarj aleti]', '[ipad pro kılıfı]', '[airpods kılıfı]',
      '[gürgençler ankamall]', '[gürgençler cevahir]', '[gürgençler cepa]',
      '[gürgençler mall of]', '[gürgençler viaport]', '[gürgençler konya]',
      '[gürgençler mersin]', '[gürgençler optimum]', '[gürgençler forum]',
      '[gürgençler şikayetvar]', '[gürgençler şikayet]', '[gürgençler ekşi]',
      '[gürgençler iade]', '[gürgençler güvenilir mi]', '[gürgençler nedir]',
      '[iphone 12]', '[gürgençler iphone 14]', '[gürgençler iphone 7]',
      '[apple watch 3]', '[ipad air 3]', '[gürgençler n11]', '[gürgençler gittigidiyor]',
      '"özgençler"', '[macstorey]',
      'iphone', 'macbook', 'airpods', 'kılıf', 'tamir', 'aksesuar',
      'trendyol', 'hepsiburada', 'teknosa', 'sahibinden', 'ikinci el', 'senet', 'taksit',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhone17',
    label: 'iPhone 17',
    keywords: [
      '[iphone 17]', '[iphone 17 fiyat]', '[iphone 17 ön sipariş]', '[iphone 17 satışta]',
      '[apple iphone 17]',
    ],
    negatives: [
      '[iphone 17 fiyatı ne kadar]', '[iphone 17 kaç tl]', '[iphone 17 kaç para]',
      '[iphone 17 modelleri]', '[iphone 17 fiyat listesi]', '[iphone 17 ne kadar]',
      '[17 iphone fiyat]', '[17 air]', '[iphone air 17]', '[iphone 17 pro max]',
      '[ايفون 17]', '[айфон 17]', '[سعر ايفون 17]',
      '[ايفون 17 برو ماكس]', '[مواصفات iphone 17 pro max]',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhone17Pro',
    label: 'iPhone 17 Pro / Pro Max',
    keywords: [
      '"iphone 17 pro"', '[iphone 17 pro]', '[iphone 17 pro fiyat]', '[apple iphone 17 pro]',
      '[iphone 17 pro ön sipariş]', '[iphone 17 pro satışta]',
      '[iphone 17 pro max]', '[17 pro max]', '[ıphone 17 pro max]', '[iphone 17 promax]',
      '[iphone pro max 17]', '[17 iphone pro max]', '[apple iphone 17 pro max]',
      '[iphone 17 pro max ön sipariş]',
    ],
    negatives: [
      '[iphone 17 pro max цена]', '[iphone 17 pro max flip]', '[iphone 17 pro kaç lira]',
      '[ayfon 17 pro max ne kadar]', '[ayfon 17 pro max kaç tl]',
      '[سعر الايفون 17 برو ماكس في مصر]', '[ايفون 17 برو ماكس]',
      '[حجز ايفون 17 برو ماكس]', '[كم سعر ايفون 17 برو ماكس]',
      '[سعر ايفون 17 برو max]', '[سعر الايفون 17 برو ماكس]',
      '[айфон 17 про макс]', '[كم سعر الايفون 17 برو ماكس]',
      '[iphone 17 pro max جرير]',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhoneAir',
    label: 'iPhone Air',
    keywords: [
      '[iphone air]', '[iphone air fiyat]', '[iphone 17 air]', '[apple 17 air]',
      '[apple iphone air]', '[iphone air pro]', '[iphone air pro max]',
      '[ıphone 17 air]', '[iPhone Air Karşılaştırma]',
    ],
    negatives: [
      '[iphone 17 air ne zaman çıkacak]', '[iphone 17 air nasıl olacak]',
      '[iphone 17 air mediamarkt]', '[iphone 17 air kaç gram]',
      '[iphone 17 air epey]', '[iphone 17 air vs 16e]',
      '[iphone 17 air vs 15 pro max]', '[iphone 17 vs 17 air]',
      '[iphone 17 17 air]', '[iphone 17air]',
      '[galaxy s25 edge vs iphone 17 air]', '[iphone air 1]',
      '[iphone air epey]', '[aiphone air]',
      '[apple 17 air özellikleri]', '[ıphone 17 air fiyat]', '[ıphone air fiyat]',
      '[айфон эйр]', '[айфон 17 аир]', '[17 айфон аир]',
      '[айфон air]', '[айфон аир 17]', '[air айфон]',
      '[ايفون 17 air]',
    ]
  },
  {
    campaign: 'SRCH_GNRC_AirpodsPro3',
    label: 'AirPods Pro 3',
    keywords: [
      '[airpods pro 3]', '[airpods pro 3 fiyat]', '[apple airpods pro 3]',
      '[airpods pro 3 ön sipariş]', '[airpods pro 3 satışta]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_Watch11',
    label: 'Apple Watch Series 11',
    keywords: [
      '"apple watch 11"', '[apple watch 11]', '[apple watch series 11]', '[watch 11]',
      '"apple watch series 11 fiyat"', '[apple watch series 11 fiyat]',
      '"apple watch series 11 ön sipariş"', '[apple watch series 11 ön sipariş]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_WatchSE3',
    label: 'Apple Watch SE 3',
    keywords: [
      '"apple watch se 3"', '[apple watch se 3]', '[watch se 3]',
      '[apple watch se 3 fiyat]', '[apple watch se 3 ön sipariş]', '[apple watch se 3 satışta]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_WatchUltra3',
    label: 'Apple Watch Ultra 3',
    keywords: [
      '[apple watch ultra 3]', '[watch ultra 3]', '[apple watch ultra 3 fiyat]',
      '[apple watch ultra 3 ön sipariş]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_A16',
    label: 'iPad (A16)',
    keywords: [
      '[ipad]', '[ipad a16]', '[apple ipad a16]', '[ipad a16 çip]', '[ipad a16 çipli]',
      '[a16 çipli ipad]', '[a16 işlemcili ipad]', '[ipad eğitim indirimi]', '[ipad öğrenci indirimi]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_air',
    label: 'iPad Air',
    keywords: [
      'ipad air', 'ipad air m3', '[ipad air 13 inch]', '[ipad air m3 13 inch]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_mini',
    label: 'iPad Mini',
    keywords: [
      '[ipad mini]',
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPadM5',
    label: 'iPad Pro M5',
    keywords: [
      '"ipad m5"', '"ipad pro m5"',
    ],
    negatives: [
      '[17 air]', '[iphone 17 ne kadar]', '[iphone 17 kaç tl]', '[iphone 17 kaç para]',
      '[iphone 17 fiyat listesi]', '[iphone 17 fiyatı ne kadar]', '[iphone 17 modelleri]',
      '[17 iphone fiyat]', '[iphone air 17]', '[iphone 17 pro max]',
      '[ايفون 17]', '[айфон 17]', '[سعر ايفون 17]',
      '[ايفون 17 برو ماكس]', '[مواصفات iphone 17 pro max]',
    ]
  },
  {
    campaign: 'SRCH_GNRC_Macbook_Air_M4',
    label: 'MacBook Air M4',
    keywords: [
      '"macbook air"', '"macbook air m4"',
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook_Pro_M4',
    label: 'MacBook Pro M4',
    keywords: [
      '"macbook pro"', '"macbook pro m4"', '"macbook pro m4 13 inch"',
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook',
    label: 'MacBook (Genel)',
    keywords: [
      '"macbook"', '"gurgencler macbook"', '"gürgençler mac"',
    ],
  },
  {
    campaign: 'SRCH_Competitor',
    label: 'Rakipler',
    keywords: [
      '[troy]', '"troy apple"', 'troystore', 'troyestore', 'troyapple', 'troy iphone',
      '"troy kanyon"', '[troy ankara]', '[troy izmir]', '[troy akbatı]',
      '[troy macbook]', '[troy ipad]', '[troy watch]', '[Troy Gordion]',
      '[troy vadi istanbul]', '[troy aqua florya]', '[troy agora avm]',
      '[pozitif teknoloji]', '[PT Apple]', '[PT macbook]',
      '[Pozitif teknoloji apple]', '[Pozitif teknoloji macbook]',
    ],
    negatives: [
      'kart', 'ödeme yöntemi', 'ödeme', 'troy film', 'troy kart',
      'troy çanakkale', 'troy kredi kartı',
      '"gürg"', '"özgençler"',
      '[gürgençler batarya değişimi]', '[gürgençler cam değişimi]',
      '[gürgençler şikayetvar]', '[gürgençler şikayet]', '[gürgençler ekşi]',
      '[gürgençler iade]', '[gürgençler n11]', '[gürgençler gittigidiyor]',
      '[iphone kılıf]', '[airpods kılıf]', '[ipad klavye]', '[apple kılıf]',
      '[iphone batarya değişimi]', '[iphone xr ekran değişimi]',
      '[iphone 12]', '[gürgençler iphone 14]',
      'iphone', 'macbook', 'airpods', 'kılıf', 'tamir',
      'trendyol', 'hepsiburada', 'teknosa', 'sahibinden',
      'ikinci el', 'Pozitif', 'senet',
    ]
  },
];

const MATCH_COLORS = {
  Phrase: 'bg-blue-50 text-blue-700 border-blue-200',
  Exact: 'bg-purple-50 text-purple-700 border-purple-200',
  Broad: 'bg-amber-50 text-amber-700 border-amber-200',
};

const NEG_COLORS = {
  Phrase: 'bg-orange-50 text-orange-700 border-orange-200',
  Exact: 'bg-red-50 text-red-700 border-red-200',
  Broad: 'bg-rose-50 text-rose-600 border-rose-200',
};

function getMatchType(kw) {
  if (kw.startsWith('[')) return 'Exact';
  if (kw.startsWith('"')) return 'Phrase';
  return 'Broad';
}

const MAX_VISIBLE = 10;

export default function SearchKeywordReportV3() {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedPos, setExpandedPos] = useState({});
  const [expandedNeg, setExpandedNeg] = useState({});

  const togglePos = (id) => setExpandedPos(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleNeg = (id) => setExpandedNeg(prev => ({ ...prev, [id]: !prev[id] }));

  const filteredData = useMemo(() => {
    const q = searchQuery.toLowerCase().trim();
    if (!q) return CAMPAIGN_DATA;
    return CAMPAIGN_DATA.map(c => ({
      ...c,
      keywords: c.keywords.filter(kw => kw.toLowerCase().includes(q) || c.label.toLowerCase().includes(q)),
      negatives: c.negatives
        ? c.negatives.filter(kw => kw.toLowerCase().includes(q) || c.label.toLowerCase().includes(q))
        : undefined,
    })).filter(c => c.keywords.length > 0 || (c.negatives && c.negatives.length > 0));
  }, [searchQuery]);

  const totalKeywords = useMemo(() => filteredData.reduce((s, c) => s + c.keywords.length, 0), [filteredData]);
  const totalNegatives = useMemo(() => filteredData.reduce((s, c) => s + (c.negatives ? c.negatives.length : 0), 0), [filteredData]);

  return (
    <div className="min-h-screen p-4 md:p-6 space-y-6 max-w-screen-2xl mx-auto bg-[#f6f8ff]/70">
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-50 border border-blue-100 shadow-sm rounded-xl">
              <img src="/google_ads.webp" alt="Google Ads" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Search Keyword Report — V3</h1>
              <p className="text-sm text-gray-500 mt-0.5">Gürgençler — Kampanya bazlı keyword & negatif dağılımı</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-sm flex-wrap">
            <AccountSwitcher platform="GOOGLE_ADS" />
            <span className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg font-medium">{filteredData.length} Kampanya</span>
            <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg font-medium">{totalKeywords} Keyword</span>
            <span className="px-3 py-1.5 bg-red-50 text-red-700 rounded-lg font-medium">{totalNegatives} Negatif</span>
          </div>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Keyword veya kampanya ara..."
          className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl text-sm shadow-sm focus:ring-2 focus:ring-blue-100 focus:border-blue-300 outline-none transition-all"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {filteredData.map((c) => {
          const isPosExpanded = expandedPos[c.campaign];
          const isNegExpanded = expandedNeg[c.campaign];
          const visibleKw = isPosExpanded ? c.keywords : c.keywords.slice(0, MAX_VISIBLE);
          const hiddenKw = c.keywords.length - MAX_VISIBLE;
          const negs = c.negatives || [];
          const visibleNeg = isNegExpanded ? negs : negs.slice(0, MAX_VISIBLE);
          const hiddenNeg = negs.length - MAX_VISIBLE;

          return (
            <div key={c.campaign} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="font-semibold text-gray-900 text-base">{c.label}</h2>
                  <p className="text-xs text-gray-400 mt-0.5">
                    {c.keywords.length} keyword{negs.length > 0 && ` · ${negs.length} negatif`}
                  </p>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs px-2.5 py-1 bg-emerald-50 text-emerald-600 rounded-full font-medium">{c.keywords.length}</span>
                  {negs.length > 0 && (
                    <span className="text-xs px-2.5 py-1 bg-red-50 text-red-600 rounded-full font-medium">-{negs.length}</span>
                  )}
                </div>
              </div>

              {c.keywords.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {visibleKw.map((kw, i) => {
                    const mt = getMatchType(kw);
                    return (
                      <span key={i} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium ${MATCH_COLORS[mt]}`}>
                        <Tag className="w-3 h-3 flex-shrink-0 opacity-50" />
                        {kw}
                      </span>
                    );
                  })}
                </div>
              )}
              {hiddenKw > 0 && (
                <button
                  onClick={() => togglePos(c.campaign)}
                  className="mt-2 text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1 transition-colors self-start"
                >
                  {isPosExpanded ? 'Gizle' : `+${hiddenKw} keyword daha göster`}
                  <svg className={`w-3.5 h-3.5 transition-transform ${isPosExpanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                </button>
              )}

              {negs.length > 0 && (
                <>
                  <div className="mt-4 mb-3 flex items-center gap-2">
                    <div className="h-px flex-1 bg-red-100"></div>
                    <span className="text-[10px] font-semibold text-red-400 uppercase tracking-wider flex items-center gap-1">
                      <ShieldOff className="w-3 h-3" /> Negatif Keywordler
                    </span>
                    <div className="h-px flex-1 bg-red-100"></div>
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {visibleNeg.map((kw, i) => {
                      const mt = getMatchType(kw);
                      return (
                        <span key={i} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium ${NEG_COLORS[mt]}`}>
                          <ShieldOff className="w-3 h-3 flex-shrink-0 opacity-50" />
                          {kw}
                        </span>
                      );
                    })}
                  </div>
                  {hiddenNeg > 0 && (
                    <button
                      onClick={() => toggleNeg(c.campaign)}
                      className="mt-2 text-xs text-red-500 hover:text-red-700 font-medium flex items-center gap-1 transition-colors self-start"
                    >
                      {isNegExpanded ? 'Gizle' : `+${hiddenNeg} negatif daha göster`}
                      <svg className={`w-3.5 h-3.5 transition-transform ${isNegExpanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                    </button>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>

      {filteredData.length === 0 && (
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100">
          <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-700">Sonuç bulunamadı</h3>
          <p className="text-sm text-gray-500 mt-1">Arama terimini değiştirmeyi dene</p>
        </div>
      )}

      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500">
          <span className="font-medium text-gray-600">Pozitif:</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-blue-100 border border-blue-200"></span> Phrase</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-purple-100 border border-purple-200"></span> Exact</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-amber-100 border border-amber-200"></span> Broad</span>
          <span className="mx-1 text-gray-300">|</span>
          <span className="font-medium text-gray-600">Negatif:</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-orange-100 border border-orange-200"></span> Phrase</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-red-100 border border-red-200"></span> Exact</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-rose-100 border border-rose-200"></span> Broad</span>
        </div>
      </div>
    </div>
  );
}
